import * as Updates from 'expo-updates';

type RequestBody = ?(string | Object);

const baseUrl = 'https://calc.al/api/';
//const pinUrl = 'https://calc.al/workspace/calcal/data/pinLogin.php';
const pinUrl = 'https://calc.al/api/token';
const demoUrl = baseUrl + 'demos';
const CLIENTID = 'gUoW6HEvh0GIgAYHWBYlQS6BrGwd9q5pkulqc0Wt';

// This is used in order to see requests on the Chrome DevTools
//It can't be left in because https://calcal.uk/oauth/authorize?oauth=token throws a wobbler at the CORS OPTIONS request
/*XMLHttpRequest = GLOBAL.originalXMLHttpRequest ?
	GLOBAL.originalXMLHttpRequest :
	GLOBAL.XMLHttpRequest;
/*	*/

export default class CalCalDataApi {
	//the gets and posts are local awaits. Other loads call their callbacks
	static async dataLoad(table, jwt, callback, accept = null) {
		let res = await this.get(baseUrl + table, jwt, accept ? { Accept: accept } : {});
		if (!res) return callback({ success: false, error: 'Nothing received' });
		if (res.status && res.status == 404) res.error = res.title;
		if (res.status && res.status == 500) res.error = res.title;
		if (res.status && (res.status == 401 || (res.status == 'error' && res.error == 'Expired token'))) Updates.reloadAsync(); //boom
		res.error && console.warn(res);
		__DEV__ && console.log('dataLoad', table, res);
		callback(res);
	}

	static async dataLoadWithHeads(table, jwt, callback, moreHeads = {}, sendCookies = false) {
		let res = await this.get(
			baseUrl + table,
			jwt,
			{
				'x-client-id': CLIENTID, //do we need this??! Only for sign-up
				...moreHeads
			},
			sendCookies
		);
		__DEV__ && console.log('GETting with heads ', baseUrl + table);
		if (res.status && res.status == 404) res.error = res.title;
		if (res.status && res.status == 500) res.error = res.title;
		res.error && console.warn(res);
		__DEV__ && console.log('dataLoad', table, res);
		callback(res);
	}

	//only used by PIN reset
	static async dataPutWithHeads(table, data, jwt, callback, moreHeads = {}, sendCookies = false) {
		let res = await this.put(
			baseUrl + table,
			data,
			jwt,
			{
				client_id: CLIENTID,
				...moreHeads
			},
			sendCookies
		);
		__DEV__ && console.log('dataUpdate', table, data, res); //res.success of error. Errors
		callback(res);
	}

	static async dataPostWithHeads(table, data, jwt, callback, moreHeads = {}, sendCookies = false) {
		let res = await this.post(
			baseUrl + table,
			data,
			jwt,
			{
				client_id: CLIENTID,
				...moreHeads
			},
			sendCookies
		);
		__DEV__ && console.log('dataPost', table, data, res); //res.success of error. Errors
		callback(res);
	}

	static async dataUpdate(table, data, jwt, callback) {
		let res = await this.put(baseUrl + table, data, jwt);
		//if(res.status && res.status==404) res.error = res.title;
		if (__DEV__) console.log('dataUpdate', table, data, res); //res.success of error. Errors
		callback(res);
	}

	static async dataInsert(table: string, data: Object, jwt: string, callback: Function) {
		let res = await this.post(baseUrl + table, data, jwt);
		if (__DEV__) console.log('dataInsert', table, res); //res.success of error. Errors
		//Get back {success: true, id: 46, client_id: null, record: {...} }
		callback(res);
	}

	static async dataDelete(path, jwt, callback) {
		let res = await this.delete(baseUrl + path, jwt);
		//if(res.status && res.status==404) res.error = res.title;
		callback(res);
	}

	static async pinLogin(pin, authToken) {
		let response = await this.post(
			pinUrl,
			{ pin: pin },
			null,
			{
				token: authToken
				//client_id: CLIENTID,
				//client_secret: SECRET
			},
			true //cookies
		);
		return response;
	}

	static async demoLogin(demoNum) {
		let response = await this.post(demoUrl, { demo_id: demoNum }, null, {
			'x-client-id': CLIENTID
		});
		return response;
	}

	static async get(url, jwt, moreHeads = {}, sendCookies = false) {
		var heads = {
			Accept: 'application/json',
			'X-Token': 'Bearer ' + jwt,
			...moreHeads
		};
		//__DEV__ && console.log('GETting ', url);
		let response = await fetch(url, {
			method: 'GET',
			headers: heads,
			redirect: 'follow',
			credentials: sendCookies ? 'include' : 'same-origin'
		});
		let result;
		//__DEV__ && console.log(response);
		try {
			result = await response.json();
			//result.status = response.status;
			return result;
		} catch (e) {
			console.warn('ERROR DATA GOT', response);
			return { status: response.status, error: e };
		}
	}

	static async post(url, body, jwt, extras, cookies = false) {
		//if (__DEV__) console.log('posting', body, extras);
		let response = await fetch(url, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				'X-Token': 'Bearer ' + jwt,
				...extras
			},
			credentials: cookies ? 'include' : 'same-origin',
			body: JSON.stringify(body)
		});

		// It's possible that the server sends us back something
		// that isn't json here, so just ignore it if we can't
		// parse it
		let result;
		//if (__DEV__) console.log('POSTting ', url, body, response);
		try {
			result = await response.json();
		} catch (e) {
			console.log('POST error');
			result = response.status == 200 ? { success: true, status: 200 } : { status: response.status, error: e };
		}

		return result;
	}

	static async put(url, body, jwt, extras, sendCookies = false) {
		let response = await fetch(url, {
			method: 'put',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				'X-Token': 'Bearer ' + jwt,
				...extras
			},
			body: JSON.stringify(body),
			credentials: sendCookies ? 'include' : 'same-origin'
		});

		//if (__DEV__) console.log('PUTting ', url, body, response);
		let result;
		try {
			result = await response.json();
		} catch (e) {
			result = response.status == 200 ? { success: true, status: 200 } : { status: response.status, error: e };
		}

		return result;
	}

	static async delete(url, jwt) {
		let response = await fetch(url, {
			method: 'delete',
			headers: {
				Accept: 'application/json',
				'X-Token': 'Bearer ' + jwt
			}
		});

		let result;
		try {
			result = await response.json();
		} catch (e) {
			result = response.status == 200 ? { success: true } : { error: e };
		}
		result.status = response.status;
		if (__DEV__) console.log('DELETINGting ', url, response, result);
		return result;
	}
}
